<template>
<div class="MEquityLearning">
    <Header></Header>
    <div class="content_warp">
        <div class="top_box">
            <p class="p_title">股权学习</p>
            <p class="p_desc">线上课程 、线下课程自由选择，深入了解股权知识</p>
            <button @click="MessageBtn" class="btn">留言咨询</button>
        </div>
        <div class="warp1">
            <p class="title_text">线上课堂</p>
            <div class="course_warp">
                <div @click="courseClick(item.courseid)" class="course_item_box" v-for="(item, index) in recommendCourseData" :key="index">
                    <img v-lazy="item.coverurl" alt="">
                    <p>{{item.subject}}</p>
                </div>
            </div>
            <div @click="moreCourse" class="more_text">
                <span>查看更多</span>
                <img :src="require('@/common/images/gujingimgs/icon_more.png')" alt="">
            </div>
        </div>
        <div class="img_warp">
            <img :src="require('@/common/images/gujingimgs/mlearn/img_1.png')" alt="">
            <img :src="require('@/common/images/gujingimgs/mlearn/img_2.png')" alt="">
            <img :src="require('@/common/images/gujingimgs/mlearn/img_3.png')" alt="">
            <img :src="require('@/common/images/gujingimgs/mlearn/img_4.png')" alt="">
            <img :src="require('@/common/images/gujingimgs/mlearn/img_5.png')" alt="">
            <img :src="require('@/common/images/gujingimgs/mlearn/img_6.png')" alt="">
        </div>
        <div class="warp4">
            <p>联系我们，了解更多需求定制服务</p>
            <div @click="MessageBtn" class="btn_div">留言咨询</div>
        </div>
    </div>
    <Footer></Footer>
    <transition name="slide-fade">
        <div>
            <img class="contact_img" v-show="!showContactTel && show" @click="showContactTel = !showContactTel" :src="require('@/common/images/gujingimgs/icon_contact.png')" alt="">
            <img class="contact_tel_img" v-show="showContactTel && show" @click="showContactTel = !showContactTel" :src="require('@/common/images/gujingimgs/icon_tel.png')" alt="">
            <img class="gotop_img" @click="goTop" v-show="show" :src="require('@/common/images/gujingimgs/go_top.png')" alt="">
        </div>
    </transition>
</div>
</template>

<script>
import {getRecommendCourse} from 'api/gujingApi'
import Header from 'views/gjMobile/components/Header'
import Footer from 'views/gjMobile/components/Footer'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MEquityLearning',
    data() {
        return {
            showContactTel: false,
            show: false,
            recommendCourseData: []
        }
    },
    created() {
        // 判断是移动端还是PC端 并跳转到相应页面
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'EquityLearning'
            })
        }
    },
    activated() {
        $('html,body').animate({scrollTop:'0px'},0)
    },
    mounted() {
        $('html,body').animate({scrollTop:'0px'},0)
        this.findRecommendCourse()
        let _this = this
        $(window).scroll(function () {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let clientHeight = document.body.clientHeight / 2
            if(scrollTop >= clientHeight){
                _this.show = true
            }
            else{
                _this.show = false
            }
        })
    },
    methods: {
        // 留言咨询
        MessageBtn() {
            this.$router.push({name: 'Msg'})
        },
        // 回到顶部
        goTop() {
            $('html,body').animate({scrollTop:'0px'},300)
            // document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        // 课程点击
        courseClick(id) {
            // 线上地址： http://ke.capwhale.com/m/mindex
            this.$router.push({name: 'MCourseView', query: {cid: id}})
            this.setRefresh(true)
        },
        // 更多课程
        moreCourse() {
            this.$router.push({name: 'MIndex'})
            this.setRefresh(true)
        },
        // 获取股鲸推荐课程
        findRecommendCourse() {
            this.setLoading(true)
            let params = {}
            getRecommendCourse({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    // this.recommendCourseData = data.data.content
                    this.recommendCourseData = [data.data.content[0], data.data.content[1], data.data.content[2]]
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {Header,Footer}
}
</script>

<style lang="scss" type="text/scss">
.MEquityLearning {
    position: relative;
    background-color: #F5F7FA;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family:PingFangSC-Medium,PingFang SC;
    .content_warp {
        flex: 1;
        // padding-bottom: 0.2rem;
        .top_box {
            height: 5.6rem;
            background: url('../../../common/images/gujingimgs/intro-bg.png') no-repeat center;
            background-size: 100% 100%;
            color: #FFF;
            padding: 0 0.32rem;
            padding-top: 1.6rem;
            box-sizing: border-box;
            .p_title {
                font-size: 0.48rem;
                line-height: 0.68rem;
                font-weight: bold;
            }
            .p_desc {
                margin: 0.4rem 0;
                font-size: 0.3rem;
                line-height: 0.46rem;
            }
            .btn {
                width: 2.2rem;
                height: 0.6rem;
                font-size: 0.28rem;
                background:linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                border: none;
                border-radius: 0.3rem;
            }
        }
        .title_text {
            position: relative;
            text-align: center;
            font-size: 0.36rem;
            line-height: 0.5rem;
            margin-bottom: 0.6rem;
            color: #333;
            font-weight: bold;
            &::before {
                content: '';
                position: absolute;
                margin: auto;
                bottom: -0.12rem;
                left: 0;
                right: 0;
                width:0.36rem;
                height:0.04rem;
                background: #409EFF;
            }
        }
        .warp1 {
            background-color: #fff;
            padding: 0 0.32rem;
            padding-top: 0.56rem;
            padding-bottom: 0.48rem;
            .course_warp {
                .course_item_box {
                    margin-bottom: 0.48rem;
                    &>img {
                        // width: 100%;
                        background:rgba(216,216,216,1);
                        width: 6.86rem;
                        height: 3.86rem;
                        min-width: 6.86rem;
                        min-height: 3.86rem;
                        border-radius:0.04rem;
                    }
                    &>p {
                        margin-top: 0.32rem;
                        line-height: 0.46rem;
                        font-size: 0.32rem;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
            }
            .more_text {
                margin-top: 0.6rem;
                height: 0.4rem;
                display: flex;
                align-items: center;
                justify-content: center;
                &>span {
                    color: #666;
                    font-size: 0.28rem;
                    margin-right: 0.12rem;
                }
                &>img {
                    width: 0.14rem;
                    height: 0.22rem;
                }
            }
        }
        .img_warp {
            &>img {
                width: 100%;
            }
        }
        .warp4 {
            height: 4.54rem;
            background: url('../../../common/images/gujingimgs/bg1.png') no-repeat center;
            background-size: 100% 100%;
            color: #FFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &>p {
                line-height: 0.54rem;
                font-size: 0.38rem;
                margin-bottom: 0.62rem;
            }
            .btn_div {
                border: 0.01rem solid #fff;
                box-sizing: border-box;
                font-size: 0.28rem;
                width: 2.2rem;
                height: 0.6rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.6rem;
            }
        }
    }
    .gotop_img, .contact_img, .contact_tel_img {
        width: 1.16rem;
        height: 1.16rem;
        position: fixed;
        right: 0.2rem;
        bottom: 2.15rem;
        opacity: 1;
    }
    .contact_tel_img {
        width: 3.02rem;
    }
    .gotop_img {
        bottom: 1rem;
    }
}
.slide-fade-enter-active, .slide-fade-leave-active {
    transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
}
</style>